var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import styled from '../../../../styled';
import Text from '../../../text';
import dayjs, { TODAY } from '../day';
import { Column, generateColumnButtonStyle, } from './Column';
const WeekdayColumn = styled(Column) `
  color: ${({ theme }) => theme.colors.INK_500};
  width: 2.25rem;
  height: 2.25rem;
  font-weight: 600;
`;
const DateColumn = styled(Column) `
  ${(_a) => {
    var { isDefault, isSelected, isFromSelected, isToSelected, isDisabled, isPeriod } = _a, settings = __rest(_a, ["isDefault", "isSelected", "isFromSelected", "isToSelected", "isDisabled", "isPeriod"]);
    return generateColumnButtonStyle({
        isDefault,
        isSelected,
        isFromSelected,
        isToSelected,
        isDisabled,
        isPeriod,
    }, Object.assign({ borderRadius: 18, selectedPointBorderRadius: 18, isSelectedPointCircle: true }, settings));
}}

  width: 2.25rem;
  height: 2.25rem;
  margin-bottom: 0.25rem;
`;
const DateContainer = styled.div `
  > ${DateColumn}:first-of-type {
    margin-left: ${({ offset }) => offset * 2.25}rem;
  }
`;
const DateRangesCalendarView = ({ ranges, targetDate, getDateColor, isToday, date, handleClick, }) => {
    const { fromSelectedIndexes, toSelectedIndexes, periodIndexes } = ranges.reduce((result, eachRange, index) => {
        return {
            fromSelectedIndexes: [
                ...result.fromSelectedIndexes,
                ...(targetDate.isSame(eachRange.from, 'date') ? [index] : []),
            ],
            toSelectedIndexes: [
                ...result.toSelectedIndexes,
                ...(targetDate.isSame(eachRange.to, 'date') ? [index] : []),
            ],
            periodIndexes: [
                ...result.periodIndexes,
                ...(targetDate.isBetween(eachRange.from, eachRange.to, 'date', '[]')
                    ? [index]
                    : []),
            ],
        };
    }, {
        fromSelectedIndexes: [],
        toSelectedIndexes: [],
        periodIndexes: [],
    });
    return (React.createElement(DateColumn, Object.assign({ key: targetDate.toString(), isDefault: isToday, isFromSelected: fromSelectedIndexes.length > 0, isToSelected: toSelectedIndexes.length > 0, isPeriod: periodIndexes.length > 0, onClick: handleClick }, ((getDateColor === null || getDateColor === void 0 ? void 0 : getDateColor({
        fromSelectedIndexes,
        toSelectedIndexes,
        periodIndexes,
        targetDate,
    })) || {})), date.toString()));
};
const DateCalendarView = ({ lang, target, selectedDate, selectedFrom, selectedTo, ranges, getDateColor, onSelect, disabledDate, }) => {
    const dates = useMemo(() => new Array(target.daysInMonth()).fill(null).map((_, i) => i + 1), [target]);
    const offset = target.startOf('month').day();
    const weekdays = useMemo(() => dayjs(lang).localeData().weekdaysMin(), [lang]);
    return (React.createElement(React.Fragment, null,
        weekdays.map(weekdayLabel => (React.createElement(WeekdayColumn, { key: weekdayLabel },
            React.createElement(Text, { lang: lang, fontType: "Caption", color: "INK_500" }, weekdayLabel)))),
        React.createElement(DateContainer, { offset: offset }, dates.map((date) => {
            const targetDate = target.date(date);
            const isDisabled = disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(targetDate.toDate());
            if (isDisabled) {
                return (React.createElement(DateColumn, { key: targetDate.toISOString(), isDisabled: true }, date.toString()));
            }
            const isToday = targetDate.isSame(TODAY, 'date');
            const handleClick = () => onSelect(targetDate.clone());
            if (ranges) {
                return (React.createElement(DateRangesCalendarView, { key: targetDate.toISOString(), ranges: ranges, targetDate: targetDate, getDateColor: getDateColor, isToday: isToday, date: date, handleClick: handleClick }));
            }
            const from = selectedFrom || selectedDate;
            const to = selectedTo || selectedDate;
            const isPeriod = from &&
                to &&
                targetDate.isBetween(from, to, 'date', '[]');
            const isSelected = !selectedFrom &&
                !selectedTo &&
                selectedDate &&
                targetDate.isSame(selectedDate, 'date');
            const isFromSelected = from && targetDate.isSame(from, 'date');
            const isToSelected = to && targetDate.isSame(to, 'date');
            return (React.createElement(DateColumn, { key: targetDate.toISOString(), isDefault: isToday, isSelected: isSelected, isFromSelected: isFromSelected, isToSelected: isToSelected, isPeriod: isPeriod, onClick: handleClick }, date.toString()));
        }))));
};
export default DateCalendarView;
//# sourceMappingURL=DateCalendarView.js.map